// extracted by mini-css-extract-plugin
module.exports = {"fieldContainer":"Dialogs-fieldContainer","fieldLabel":"Dialogs-fieldLabel","dialogContainer":"Dialogs-dialogContainer","background":"Dialogs-background","error":"Dialogs-error"};